import React, { FunctionComponent } from "react";
import styled from "styled-components";

import Device from "@/utils/device";

type TitleProps = {
  children: React.ReactNode;
  colour?: string;
  uppercase?: boolean;
};

type StyleProps = {
  colour?: string;
  uppercase?: boolean;
};

const StepForwardTitle: FunctionComponent<TitleProps> = (props) => {
  return (
    <S.Title colour={props.colour} uppercase={props.uppercase}>
      {props.children}
    </S.Title>
  );
};

const S = () => {};

S.Title = styled.h2<StyleProps>`
  font-family:
    Roxborough CF,
    sans-serif;
  font-weight: 700;
  text-transform: uppercase;
  font-size: 4rem;
  line-height: 3.4rem;
  letter-spacing: -0.3rem;
  color: ${(p) => p.colour};

  @media ${Device.mobile} {
    font-size: 5rem;
    line-height: 4rem;
    letter-spacing: -0.4rem;
  }

  @media ${Device.tablet} {
    font-size: 6rem;
    line-height: 4.7rem;
  }

  @media ${Device.desktop} {
    font-size: 7rem;
    line-height: 6.5rem;
    letter-spacing: -0.2rem;
  }
`;

S.FontWeightWrap = styled.span`
  font-weight: 100;
`;

export default StepForwardTitle;
